import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Icon } from '../../../../../../common/html/icon'
import { TextEllipsisStaticLine } from '../../../../../../common/textEllipsis/TextEllipsisStaticLine'

export const ColumnCellWithCollapse = ({
  ids,
  rowId,
  val,
  style,
  childIds,
  changeIds,
  fieldStyle,
}) => {
  const dispatch = useDispatch()
  const [isOpenCollapse, setIsOpenCollapse] = useState(true)
  const indexOfRowId = ids.indexOf(rowId)

  const onClickCollapse = () => {
    setIsOpenCollapse(!isOpenCollapse)
    if (isOpenCollapse) {
      const newIds = ids.filter((id) => !childIds.includes(id))
      dispatch(changeIds(newIds))
    }
    if (!isOpenCollapse) {
      const newIds = [
        ...ids.slice(0, indexOfRowId + 1),
        ...childIds,
        ...ids.slice(indexOfRowId + 1),
      ]
      dispatch(changeIds(newIds))
    }
  }

  return (
    <div
      className="dFlex alignItemsCenter"
      style={{
        marginLeft: fieldStyle.includes('T')
          ? (fieldStyle.split('T').length - 1) * 40
          : 0,
        ...style,
      }}
    >
      {childIds.length > 0 ? (
        <button
          style={{
            cursor: 'pointer',
            border: 'none',
            backgroundColor: 'transparent',
            paddingLeft: 0,
          }}
          className="alignItemsCenter"
          onClick={onClickCollapse}
        >
          <Icon
            className={`${
              isOpenCollapse ? 'icon-caret-bottom' : 'icon-caret-right'
            }`}
            style={{
              fontSize: 8,
              color: '#3A414B',
              padding: isOpenCollapse ? '' : '0 2px',
            }}
          ></Icon>
        </button>
      ) : (
        <div style={{ minWidth: 16 }}></div>
      )}
      <span
        style={{
          fontWeight: fieldStyle.includes('B') ? 600 : '',
          textDecoration: `${fieldStyle.includes('U') ? 'underline' : ''}`,
          transform: fieldStyle.includes('I') ? 'skew(-25deg)' : '',
        }}
      >
        <TextEllipsisStaticLine
          zIndexTooltip={7}
          text={!val ? '' : fieldStyle.includes('P') ? val.toUpperCase() : val}
          isI18n={false}
          lineClamp={1}
        />
      </span>
    </div>
  )
}
